import { Grid, Card, Typography, Icon } from "@mui/material"
import FinancasIcon from "components/Icons/FinancasIcon"
import { FinancasTitle } from "./financas.model"
import GestaoReceberIcon from "components/Icons/GestaoReceberIcon"
import { useNavigate } from "react-router"
import { useCallback, useRef } from "react"
import { CustomButton } from "components/roundedbutton/CustomButton"
import { useAppSelector } from "redux/hooks"
import { useSnackbarCustom } from "hooks/useSnackCustom"
import { ROLES } from "roles/roles"
import { customColors, theme } from "theme";

const Financas = () => {
    const navigate = useNavigate();
    const { caixaAberto } = useAppSelector(e => e.caixa.caixaAtual);
    const token = useAppSelector(e => e.token)
    const canUseFincancas = useRef<boolean>(token.NEXUS_ROLES.includes(ROLES.CONTA_RECEBER) || token.KEY_CLOAK_ROLES.includes(ROLES.SUPER) || token.KEY_CLOAK_ROLES.includes(ROLES.ADMIN));
    const { addError, addInfo } = useSnackbarCustom()

    const onNavigateGestaoReceber = useCallback(() => {
        if (!canUseFincancas.current) {
            return addError({
                message: "Acesso não autorizado! Para acessar este menu é necessário que o usuário tenha acesso de contas a receber vinculado ao seu perfil.",
                id: "erro-role_conta-receber",
                closeable: true,
                preventDuplicate: true,
                persist: true
            })
        }
        return navigate("/financas/gestao-receber")
        //eslint-disable-next-line
    }, [])

    const onNavigateGestaoPagamento = useCallback(() => {
        return addInfo({
            message: "Em breve esta funcionalidade estará disponível.",
            id: "errro-em-breve",
            closeable: true,
            preventDuplicate: true
        })
        //eslint-disable-next-line
    }, [])

    return (
        <Grid
            container
            spacing={5}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: "center",
                height: "65vh"
            }}>
            <Grid item xl={4} md={6} sm={6} sx={{ justifyContent: 'center' }}>
                <Card onClick={onNavigateGestaoReceber}
                    variant="outlined"
                    id={'card_financas_gestao_receber_habilitado'}
                    className="card" sx={{
                        borderWidth: canUseFincancas.current ? '2px' : 0,
                        borderColor: canUseFincancas.current ? theme.palette.primary.main : theme.palette.text.primary,
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                        boxShadow: '5px 5px 10px 0 rgba(0,0,0,0.15)',
                        cursor: canUseFincancas.current ? 'pointer' : "default",
                        bgcolor: canUseFincancas.current ? 'transparent' : customColors.cinzaClaro
                    }}
                >
                    <GestaoReceberIcon
                        id="financas-gestao-receber-icon"
                        color={theme.palette.text.primary}
                        fontSize='45px'
                    />
                    <Typography
                        id="financas-gestao-receber-title"
                        sx={{
                            fontSize: '26px',
                            color: theme.palette.text.primary,
                            textAlign: 'center',
                            padding: '0 10px 0 10px',
                            userSelect: 'none'
                        }}>
                        {FinancasTitle.GESTAO_DO_RECEBER}
                    </Typography>
                </Card>
            </Grid>

            <Grid item xl={4} md={6} sm={6} sx={{ justifyContent: 'center', }}>
                <Card onClick={onNavigateGestaoPagamento}
                    variant="outlined"
                    id={'card_financas_gestao_receber_habilitado'}
                    className="card" sx={{
                        borderWidth: 0,
                        borderColor: theme.palette.text.primary,
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '20px',
                        boxShadow: '5px 5px 10px 0 rgba(0,0,0,0.15)',
                        cursor: 'auto',
                        bgcolor: customColors.cinzaClaro
                    }}>
                    <FinancasIcon
                        id="financas-financas-icon"
                        color={theme.palette.text.primary}
                        fontSize='45px'
                    />
                    <Typography
                        id="financas-financas-title"
                        sx={{
                            fontSize: '26px',
                            color: theme.palette.text.primary,
                            textAlign: 'center',
                            padding: '0 10px 0 10px',
                            userSelect: 'none'
                        }}>
                        {FinancasTitle.GESTAO_DO_PAGAMENTO}
                    </Typography>
                </Card>
            </Grid>
            <Grid item
                sx={{
                    position: 'absolute',
                    bottom: '25px',
                    width: '80%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                }}
            >
                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-configuracao-vale-presente-btn"
                    onClick={() => navigate(-1)}
                    variant="contained"
                    color="error"
                    startIcon={<Icon className='fa-solid fa-arrow-left' />}>
                    Voltar
                </CustomButton>

                <CustomButton
                    sx={{ minWidth: '80px' }}
                    id="voltar-configuracao-vale-presente-btn"
                    onClick={() => navigate("/registra-venda")}
                    disabled={!caixaAberto ? true : false}
                    variant="contained"
                    color="success"
                    startIcon={<Icon className='fa-solid fa-check' />}>
                    Ir para o pdv
                </CustomButton>
            </Grid>
        </Grid>
    )
}

export default Financas
